import { styled } from '@mui/material';
import { TextV2 } from '@insights-ltd/design-library/components';
import { Trans } from 'react-i18next';

const StyledSpan = styled(TextV2)(({ theme }) => ({
  fontWeight: `${theme.typography.fontWeightBold} !important`,
}));

interface GroupTextProps {
  groupName: string;
  groupType: string;
}

export const GroupText = ({ groupName, groupType }: GroupTextProps) => (
  <Trans
    i18nKey="ui.event-management.organisations.select-organisation.group.group-name"
    values={{ groupName, groupType }}
    components={{
      '2': (
        <StyledSpan component="span" color="textSecondary" variant="body1" />
      ),
    }}
  />
);
